export const blogContentPendingReducer = state => {
  state.content.blog.isLoading = true;
};

export const blogContentRejectedReducer = (state, action) => {
  state.content.blog.isLoading = false;
  state.content.blog.isError = action.payload;
  state.content.blog.isDataLoaded = false;
};

export const blogContentFulfilledReducer = (state, action) => {
  state.content.blog.isDataLoaded = true;
  state.content.blog.isLoading = false;

  state.content.blog.data = action.payload;
};

export const blogFactsPendingReducer = state => {
  state.content.facts.isLoading = true;
};

export const blogFactsRejectedReducer = (state, action) => {
  state.content.facts.isLoading = false;
  state.content.facts.isError = action.payload;
  state.content.facts.isDataLoaded = false;
};

export const blogFactsFulfilledReducer = (state, action) => {
  state.content.facts.isDataLoaded = true;
  state.content.facts.isLoading = false;

  state.content.facts.data = action.payload.data;
  state.content.facts.languageCode = action.payload.languageCode;
};
